'use client'

import Image from 'next/image'
import ReactCountryFlag from 'react-country-flag'
import LocalizedClientLink from '@modules/common/components/localized-client-link'
import { WORLD_CUP_TEAMS } from '@constants/world-cup'

export default function WorldCupTeams() {
  return (
    <section className="py-5 md:py-10 bg-white" aria-labelledby="world-cup-teams-heading">
      <div className="max-w-screen-2xl mx-auto px-4">
        <h2
          id="world-cup-teams-heading"
          className="text-[22px] md:text-[36px] font-black text-brand-navy text-center mb-6 md:mb-8 w-full"
        >
          Qualified National Teams
        </h2>

        <div
          className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-8 gap-x-2 gap-y-6 md:gap-y-8"
          role="list"
          aria-label="Shop by qualified national team"
        >
          {WORLD_CUP_TEAMS.map((team) => (
            <LocalizedClientLink
              key={team.id}
              href={team.href}
              role="listitem"
              className="flex flex-col items-center gap-1.5 md:gap-2 group outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-brand-navy focus-visible:ring-offset-2"
            >
              <div className="relative w-full aspect-square max-w-[96px] rounded-[10px] overflow-hidden bg-white shadow-[0_2px_10px_rgba(0,0,0,0.12)] group-hover:shadow-[0_4px_14px_rgba(0,0,0,0.18)] transition-shadow flex items-center justify-center">
                {team.image ? (
                  <Image
                    src={team.image}
                    alt={team.label}
                    fill
                    sizes="96px"
                    className="object-contain p-2"
                  />
                ) : (
                  <ReactCountryFlag
                    svg
                    countryCode={team.flagCode ?? ''}
                    style={{ width: '60%', height: '60%', borderRadius: '2px' }}
                    aria-hidden="true"
                  />
                )}
              </div>
              <span className="text-[11px] font-semibold text-[#444444] text-center whitespace-nowrap">
                {team.label}
              </span>
            </LocalizedClientLink>
          ))}
        </div>
      </div>
    </section>
  )
}
